export const formatDuration = seconds => {
  const mins = parseInt(seconds / 60)
    .toString()
    .padStart(2, '0');
  const secs = (Math.trunc(seconds) % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
};

export const isNotEmptyString = str => str && str.trim() !== '';
